export enum VideoChatInviteMode {
  Sms = 0,
  Email = 1
}
export interface VideoDeviceObject {
  id: string;
  label: string;
}
